export const categories = [
  {
    id: 1,
    name: '明星塌房',
    slug: 'mingxing-tafang',
    description: '明星翻车、人设崩塌、丑闻曝光，娱乐圈最新塌房事件第一时间汇总',
    icon: 'ri-star-line',
    articleCount: 128,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20theater%20spotlight%20on%20dark%20stage%20with%20red%20and%20warm%20orange%20lighting%2C%20cinematic%20entertainment%20atmosphere%2C%20abstract%20celebrity%20scandal%20concept%2C%20moody%20dramatic%20composition%2C%20deep%20shadows%20and%20high%20contrast&width=600&height=400&seq=cat-mingxing-01&orientation=landscape',
  },
  {
    id: 2,
    name: '网红反差',
    slug: 'wanghong-fancha',
    description: '网红人设翻车、滤镜破裂、私照外泄，揭秘屏幕背后的真实面貌',
    icon: 'ri-camera-lens-line',
    articleCount: 96,
    image: 'https://readdy.ai/api/search-image?query=Broken%20mirror%20reflection%20with%20dual%20faces%20showing%20contrast%20between%20glamorous%20and%20plain%2C%20warm%20cinematic%20lighting%20with%20red%20and%20orange%20tones%2C%20social%20media%20illusion%20concept%2C%20artistic%20dramatic%20composition&width=600&height=400&seq=cat-wanghong-01&orientation=landscape',
  },
  {
    id: 3,
    name: '不雅内幕',
    slug: 'buya-neimu',
    description: '不雅视频、私密照片、内幕交易，那些被掩盖的真相大起底',
    icon: 'ri-eye-off-line',
    articleCount: 85,
    image: 'https://readdy.ai/api/search-image?query=Closed%20red%20velvet%20curtain%20with%20mysterious%20warm%20light%20behind%20it%2C%20theater%20secret%20reveal%20concept%2C%20dramatic%20cinematic%20atmosphere%2C%20deep%20red%20and%20warm%20amber%20tones%2C%20rich%20texture%20and%20shadows&width=600&height=400&seq=cat-buya-01&orientation=landscape',
  },
  {
    id: 4,
    name: '劲爆聊天',
    slug: 'jinbao-liaotian',
    description: '微信聊天记录曝光、群聊截图、暧昧对话，深扒那些劲爆私聊内容',
    icon: 'ri-chat-3-line',
    articleCount: 112,
    image: 'https://readdy.ai/api/search-image?query=Scattered%20chat%20message%20bubbles%20floating%20in%20dark%20space%2C%20warm%20glowing%20red%20and%20orange%20text%20messages%2C%20digital%20communication%20leak%20concept%2C%20cinematic%20dramatic%20lighting%2C%20abstract%20modern%20composition&width=600&height=400&seq=cat-liaotian-01&orientation=landscape',
  },
  {
    id: 5,
    name: '独家爆料',
    slug: 'dujia-baoliao',
    description: '全网首发独家猛料、内部人士爆料、独家专访，掌握第一手资讯',
    icon: 'ri-vip-diamond-line',
    articleCount: 67,
    image: 'https://readdy.ai/api/search-image?query=Single%20glowing%20diamond%20gem%20on%20dark%20velvet%20surface%2C%20warm%20red%20and%20orange%20light%20reflections%2C%20exclusive%20luxury%20exclusive%20reveal%20concept%2C%20cinematic%20dramatic%20spotlight%20composition%2C%20rich%20contrast&width=600&height=400&seq=cat-dujia-01&orientation=landscape',
  },
  {
    id: 6,
    name: '吃瓜大全',
    slug: 'chigua-daquan',
    description: '每日精选吃瓜合集、全网热点汇总、精彩不容错过，一站式吃瓜体验',
    icon: 'ri-fire-line',
    articleCount: 203,
    image: 'https://readdy.ai/api/search-image?query=Burning%20flames%20rising%20from%20dark%20background%2C%20intense%20warm%20red%20orange%20and%20amber%20fire%20colors%2C%20hot%20trending%20news%20concept%2C%20dramatic%20cinematic%20lighting%2C%20dynamic%20movement%20and%20energy&width=600&height=400&seq=cat-chigua-01&orientation=landscape',
  },
];